import { Button, Empty, Typography } from "antd";
import emptyFridgeImg from '../../../../assets/empty-fridge.png';
import { useNavigate } from "react-router";

const { Title, Paragraph } = Typography;

type EmptyStateProps = {
  title?: string;
  message?: string;
  linkText?: string;
  onLinkClick?: () => void;
};

const EmptyStatePage = ({ title, message, linkText, onLinkClick }: EmptyStateProps) => {

  const navigate = useNavigate();
  const clickHandler = () => {
    if (onLinkClick) {
      onLinkClick();
    } else {
      navigate(-1);
    }
  };
  return (
    <Empty
      image={emptyFridgeImg}
      description={
        <>
          <Title level={5}>{title || "No Data Available"}</Title>
          <Paragraph>
            {message || "Sorry, there is no data available for this section."}
          </Paragraph>
          <Button type="primary" onClick={clickHandler}>
            {linkText || "Go Back"}
          </Button>
        </>
      }
    />
  );
};

export default EmptyStatePage;